import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  Form,
  FormGroup,
  FormFeedback
} from 'reactstrap';
import Button from '../../shared/Button';
import Checkbox from '../../shared/Checkbox';
import styles from './styles.scss';


const MIN_QUERY_LENGTH = 3;
const MAX_QUERY_LENGTH = 100;

export default class UsersListFilter extends React.Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  static get propTypes() {
    return {
      onSubmit: PropTypes.func,
      onChangeQuery: PropTypes.func,
      query: PropTypes.string,
      placeholder: PropTypes.string
    }
  }

  get isValid() {
    const { query } = this.props;
    return !query || (
      query.length >= MIN_QUERY_LENGTH &&
      query.length <= MAX_QUERY_LENGTH
    );
  }

  onSubmit(e) {
    e.preventDefault();
    this.props.onSubmit(1);
  }

  render() {
    const {
      query,
      onChangeQuery,
      placeholder
    } = this.props;
    return (
      <Container fluid={true} className='col-md-6 col-md-offset-4 mb-4 p-0 pb-2'>
        <Form onSubmit={this.onSubmit}>
          <Row>
            <Col md={10} lg={9} xl={9} className='mb-2'>
              <FormGroup>
                <InputGroup className={styles.searchField}>
                  <InputGroupAddon addonType='prepend'>
                    <InputGroupText className={styles.searchIcon}>
                      <i className='fa fa-search' />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input className={styles.search}
                    value={query}
                    placeholder={placeholder}
                    onChange={onChangeQuery}
                    invalid={!this.isValid}
                  />
                  <FormFeedback className='text-left'>
                    {`Search query should contain from ${MIN_QUERY_LENGTH} to ${MAX_QUERY_LENGTH} characters`}
                  </FormFeedback>
                </InputGroup>
              </FormGroup>
            </Col>
            <Col md={3} xl={2} className='mb-2'>
              <Button
                type='submit'
                kind='danger'
                className={`w-100`}
                disabled={!this.isValid}>
                  Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </Container>
    );
  }
}


// WEBPACK FOOTER //
// src/components/usersList/UsersListFilter/index.jsx